import DescriptionBox from './DescriptionBox';

export type { DescriptionBoxProps } from './DescriptionBox';

export default DescriptionBox;
